import { Button, Grid2 } from "@mui/material";
import CustomInput from "../genericComponents/CustomInput";
import Text from "../genericComponents/Text";
import mutationCreator from "./mutationCreator";
import { useContext, useEffect, useState } from "react";
import MutationsContext from "./MutationsContext";
import capitalizeFirstLetter from "../helpers/capitalizeFirstLetter";
import { gql, useMutation } from "@apollo/client";
import customToast from "../genericComponents/CustomToast";

const DeleteSideScreen = ({ data, setHeader, close }) => {
  const type = capitalizeFirstLetter(data.type);
  useEffect(() => {
    setHeader({ icon: data.icon, text: `Delete i18n_${type}` });
  }, [setHeader, type]);
  const [name, setName] = useState();
  const context = useContext(MutationsContext);
  const currentMutation = context
    ? context.find((x) => x.typeName === "delete" + type)
    : null;  
  const MUTATION = `mutation Delete${type}($id:UUID!) {
  delete${type}(input:  {id: $id}){
    isSuccess
    message
  }
}`;
  const buttonIsActive = name === data.object.displayName;
  const deleteItem = () => {
    if (name === data.object.displayName) {
      mutateFunction({ variables: { id: data.object.id } });
    }
  };

  const [mutateFunction, graphQlObj] = useMutation(gql(MUTATION),{
    refetchQueries:[data.type+"s"]
  });
  if (!currentMutation) {
    return "Mutation " + type + " not found";
  }

  if (graphQlObj.data) {
    const graphQlResult=graphQlObj.data["delete"+type];    
    if(graphQlResult.isSuccess){
        customToast({type:"success",message:type+" deleted"});
        close();
    }else{
        customToast({type:"error",message:graphQlResult.message});
        close();
    }
  }
  const warning = `Deleting "${data.object.displayName}". Going further will delete this ${type}.`;

  return (
    <Grid2 container spacing={1}>
      <Text text={warning} />
      <Text text={"Type the Name to delete:"} />
      <CustomInput
        value={name}
        onChange={(e) => setName(e)}
        type="String"
        placeholder={"Name"}
      />
      <Button
        onClick={deleteItem}
        disabled={!buttonIsActive}
        color="primary"
        sx={{ color: "white" }}
        variant="contained"
      >
        Delete
      </Button>
    </Grid2>
  );
};
export default DeleteSideScreen;
